module.exports = __webpack_public_path__ + "static/media/UpgradeAccountIcon.f80afeb0.svg";